import { useState } from 'react';

export type UseModalReturn = {
  open: boolean;
  handleOpen: VoidFunction;
  handleClose: VoidFunction;
  handleChange: (open: boolean) => void;
};

export function useModal(): UseModalReturn {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChange = (open: boolean) => setOpen(open);
  return { open, handleOpen, handleClose, handleChange };
}
